import { UserInDto } from '../../../types/user.dto'

export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'
export const UPDATE_CURRENT_USER_SUCCESS = 'UPDATE_CURRENT_USER_SUCCESS'
export const UPDATE_CURRENT_USER_ERROR = 'UPDATE_CURRENT_USER_ERROR'

export const RESET_UPDATE_CURRENT_USER = 'RESET_UPDATE_CURRENT_USER'


export interface UpdateCurrentUser {
  type: typeof UPDATE_CURRENT_USER
  payload: null
}

export interface UpdateCurrentUserSuccess {
  type: typeof UPDATE_CURRENT_USER_SUCCESS
  payload: UserInDto
}

export interface UpdateCurrentUserError {
  type: typeof UPDATE_CURRENT_USER_ERROR
  payload: boolean | string
}

export interface ResetUpdateCurrentUser {
  type: typeof RESET_UPDATE_CURRENT_USER
  payload: null
}

export interface State {
  data: UserInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = UpdateCurrentUser | UpdateCurrentUserSuccess | UpdateCurrentUserError | ResetUpdateCurrentUser
